module.exports = __webpack_public_path__ + "img/thumbnail_ThomsonsGazelle_j_normal.902abfeb.png";